import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Skeleton from '@material-ui/lab/Skeleton';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(theme => ({
    container: {
        zIndex: 12,
        height: '50vh',
    },
    item: {
        padding: theme.spacing(3),
        textAlign: 'center'
    },
    imageSkeleton: {
        width: '100%',
        paddingTop: '30%',
        maxHeight: '420px',
        minHeight: '180px'
    },
    skeleton: {
        margin: '24px auto'
    }
}));

export default function PageLoading(props) {
    const classes = useStyles();

    return (
        <>
            <Skeleton variant="rect" className={classes.imageSkeleton}/>
            <Grid container alignItems="center" justify="center" className={classes.container}>
                <Grid item className={classes.item}>
                    <Skeleton variant="rect" width={110} height={30} className={classes.skeleton}/>
                    <Skeleton variant="rect" width={210} height={30} className={classes.skeleton}/>
                    <Skeleton variant="rect" width={110} height={30} className={classes.skeleton}/>
                </Grid>
            </Grid>
        </>
    )
}
